import { createSelector } from 'reselect';
import { ApplicationRootState } from 'types';
import { initialState } from '../reducers/general';
import TabNames from 'containers/Header/TabNames';
import { selectHeaderDomain } from 'containers/Header/selectors';
import { ActivePanel } from '../constants/general';

/**
 * Direct selector to the general configurator state domain
 */

export const generalConfiguratorDomain = (state: ApplicationRootState) => {
  if (state.configurator) {
    return state.configurator.general || initialState;
  }
  return initialState;
};

export const makeSelectIsActiveCustomMode = () =>
  createSelector(generalConfiguratorDomain, substate => substate.customMode);

export const makeSelectContext = () =>
  createSelector(generalConfiguratorDomain, substate => substate.context);

export const makeSelectIsVisiblePieceList = () =>
  createSelector(
    generalConfiguratorDomain,
    substate => substate.isVisiblePieceList,
  );

export const makeSelectIsVisibleViewer = () =>
  createSelector(
    generalConfiguratorDomain,
    substate => substate.isVisibleViewer,
  );

export const makeSelectActivePanel = () =>
  createSelector(
    generalConfiguratorDomain,
    (substate): ActivePanel | undefined => substate.colorsPanel,
  );

export const makeSelectIsVisibleColorsPanel = (panel: ActivePanel) =>
  createSelector(makeSelectActivePanel(), colorsPanel => {
    if (!colorsPanel || !panel) return false;
    return colorsPanel === panel;
  });

export const makeSelectIsShelvesMode = () =>
  createSelector(generalConfiguratorDomain, substate => substate.shelfMode);

export const makeSelectOpenDoorsMode = () =>
  createSelector(generalConfiguratorDomain, substate => substate.openDoorsMode);

export const makeSelectDisplaySchemaDimension = () =>
  createSelector(
    generalConfiguratorDomain,
    substate => substate.showSchemaDimension,
  );
